import { getCookie } from '@lamesarv-sdk/tools';

export const getFavoritesLabel = (favorites: number, extraContent?: string) => {
  return `${favorites} Other${favorites > 1 ? 's' : ''} ${favorites > 1 ? 'have' : 'has'} favorited ${extraContent ?? ''}`;
};

export const isMobile = () => typeof window !== 'undefined' && window.innerWidth < 768;
export const isTablet = () => typeof window !== 'undefined' && window.innerWidth >= 768 && window.innerWidth < 1200;

export const getUrl = (): string => {
  if (typeof window === 'undefined') return '';
  // When embedded in an iframe, window.self !== window.top.
  // Cross-origin restrictions prevent reading window.parent.location.href directly,
  // so we fall back to document.referrer which browsers expose even cross-origin.
  const isIframe = window.self !== window.top;
  if (isIframe) {
    return document.referrer || window.location.href;
  }
  return window.location.href;
};

const referringSiteStorageKey = 'lamesarv::referringSite';
export const directReferringSite = 'direct';

// lamesarv.com and its subdomains (www, dev) count as internal navigation, not as a referring site
const isInternalHost = (host: string) => {
  const baseDomain = window.location.hostname.split('.').slice(-2).join('.');
  return host === baseDomain || host.endsWith(`.${baseDomain}`);
};

const getReferrerHost = (): string => {
  try {
    return document.referrer ? new URL(document.referrer).hostname.toLowerCase() : '';
  } catch {
    return '';
  }
};

// Runs on every full page load: an external arrival is stored for the rest of the session,
// internal navigation keeps the stored value, and a session that starts with no referrer is direct
export const captureReferringSite = () => {
  if (typeof window === 'undefined') return;

  try {
    const host = getReferrerHost();

    if (host && !isInternalHost(host)) {
      sessionStorage.setItem(referringSiteStorageKey, host);
    } else if (!sessionStorage.getItem(referringSiteStorageKey)) {
      sessionStorage.setItem(referringSiteStorageKey, directReferringSite);
    }
  } catch {
    // sessionStorage unavailable (private mode, blocked storage): getReferringSite falls back to direct
  }
};

export const getReferringSite = (): string => {
  if (typeof window === 'undefined') return '';

  try {
    return sessionStorage.getItem(referringSiteStorageKey) || directReferringSite;
  } catch {
    return directReferringSite;
  }
};

export const convertPage = (page: unknown) => {
  if (!page || typeof page !== 'string') {
    return 1;
  }

  const parsed = parseInt(page, 10);

  if (isNaN(parsed) || parsed < 1) {
    return 1;
  }

  return parsed;
};

export const getUTMData = () => {
  const utmDataSession = sessionStorage.getItem('lamesarv::utmData');

  if (utmDataSession) {
    return JSON.parse(utmDataSession);
  }

  // -- Legacy Fallback

  const utmDataCookie = {
    utm_campaign: getCookie('utm_campaign') || '',
    utm_source: getCookie('utm_source') || '',
    utm_medium: getCookie('utm_medium') || '',
    utm_term: getCookie('utm_term') || '',
    utm_content: getCookie('utm_content') || '',
    adVendor_fbId: getCookie('_fbp') || '',
    adVendor_gaId: getCookie('_ga') || '',
    adVendor_gclAu: getCookie('_gcl_au') || '',
    adVendor_bingId: getCookie('_uetvid') || '',
    adVendor_callRailId: getCookie('calltrk_session_id') || '',
    adVendor_gclId: getCookie('gclid') || '',
    adVendor_msclkId: getCookie('msclkid') || '',
  };

  return utmDataCookie;
};
